import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/authContext';

// Panel de revisión de las valoraciones de la búsqueda semántica.
// Muestra las consultas con sus 👍/👎 y las obras marcadas, para detectar dónde corregir.
const BusquedaFeedback = () => {
    const { token } = useContext(AuthContext);
    const [grupos, setGrupos] = useState(null);
    const [error, setError] = useState(null);
    const [refrescar, setRefrescar] = useState(0);

    useEffect(() => {
        let activo = true;
        const headers = {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        };
        fetch('/api/obras/busqueda_semantica_feedback', { headers })
            .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
            .then((data) => activo && setGrupos(data))
            .catch((e) => activo && setError(e.message));
        return () => { activo = false; };
    }, [refrescar, token]);

    if (error) {
        return (
            <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg text-sm text-red-600 dark:text-red-400">
                Error al cargar valoraciones: {error}
            </div>
        );
    }

    if (!grupos) {
        return <div className="mb-6 p-4 text-sm text-gray-500 dark:text-gray-400">Cargando valoraciones…</div>;
    }

    return (
        <div className="mb-6 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">Valoraciones de búsquedas semánticas</h3>
                <button
                    onClick={() => setRefrescar((v) => v + 1)}
                    className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                >
                    Refrescar
                </button>
            </div>

            {grupos.length === 0 && (
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    Todavía no hay valoraciones. Buscá en la búsqueda semántica y usá 👍/👎 sobre cada resultado.
                </p>
            )}

            <div className="space-y-4">
                {grupos.map((g) => (
                    <div key={g.consulta} className="border border-gray-200 dark:border-gray-700 rounded-md p-3">
                        <div className="flex items-center justify-between gap-2 flex-wrap">
                            <div>
                                <span className="text-sm font-medium text-gray-900 dark:text-white">
                                    “{g.consulta}”
                                </span>
                            </div>
                            <div className="flex items-center gap-3 text-sm">
                                <span className="text-green-600 dark:text-green-400">👍 {g.positivos}</span>
                                <span className="text-red-600 dark:text-red-400">👎 {g.negativos}</span>
                            </div>
                        </div>
                        <ul className="mt-2 space-y-1">
                            {g.obras.map((o, i) => (
                                <li key={i} className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-300">
                                    <span>{o.valoracion === 1 ? '👍' : '👎'}</span>
                                    <span className="font-mono">{o.id_obra}</span>
                                    <span className="text-xs text-gray-400">sim {o.sim != null ? o.sim.toFixed(3) : '–'}</span>
                                    <span className="text-xs text-gray-400">{o.usuario}</span>
                                    <span className="text-xs text-gray-400">
                                        {o.creado ? new Date(o.creado).toLocaleString() : ''}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BusquedaFeedback;